<h3 class="mt-3" i18n>Search results</h3>

<div class="table-responsive-lg">
    <table class="table table-hover">
        <thead>
            <tr>
                <th class="w-1-rem"></th>
                <th i18n>Name</th>
                <th i18n>Country</th>
                <th i18n>Service category</th>
                <th i18n>Dates</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let adsPlacement of adsPlacements">
                <td class="align-middle">
                    <span *ngIf="adsPlacement.status == 'active'" title="Active" i18n-title class="text-success" style="font-size: 1.2rem;">●</span>
                    <span *ngIf="adsPlacement.status == 'inactive'" title="Inactive" i18n-title class="text-danger" style="font-size: 1.2rem;">●</span>
                </td>
                <td class="align-middle">{{ adsPlacement.name }}</td>
                <td class="align-middle">{{ adsPlacement.organization.country }}</td>
                <td class="align-middle">{{ adsPlacement.assignment.name }}</td>
                <td class="align-middle">
                    <span *ngIf="adsPlacement.start_date">{{ adsPlacement.start_date | date: 'shortDate' }}</span>
                    <span *ngIf="!adsPlacement.start_date && adsPlacement.end_date" i18n>Not defined</span>
                    <span>&nbsp;-&nbsp;</span>
                    <span *ngIf="adsPlacement.end_date">{{ adsPlacement.end_date | date: 'shortDate' }}</span>
                    <span *ngIf="!adsPlacement.end_date" i18n>Not defined</span>    
                </td>
                <td class="align-middle text-end">
                    <a [routerLink]="['/placements', adsPlacement.id]" class="btn btn-primary btn-sm" i18n>Edit</a>&nbsp;
                    <button type="button" class="btn btn-danger btn-sm" (click)="delete(adsPlacement.id)" i18n>Delete</button>
                </td>
            </tr>
        </tbody>
    </table>
</div>